import {
    IonBackButton, IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonProgressBar,
    IonTitle,
    IonToolbar,
    IonToggle
} from '@ionic/react';
import {IonList, IonItem} from '@ionic/react';
import {isPlatform} from '@ionic/react';
import React from "react";
import useUX from "../ux/UX";
import {IonToggleCustomEvent} from "@ionic/core/dist/types/components";
import {ToggleChangeEventDetail} from "@ionic/core";
import {useRelaysQuery, useSetRelayStateMutation} from "../query/relaysQuery";
import {useGatewayConnectionStateQuery} from "../query/gatewayConnectionStateQuery";

const ControlRelays: React.FC = () => {
    const relaysQuery = useRelaysQuery();
    const relays = Object.values(relaysQuery.data ?? {});
    const setRelayStateMutation = useSetRelayStateMutation();
    const {isConnecting} = useGatewayConnectionStateQuery();
    const {presentResult} = useUX();

    async function setOn(relayId: number, on: boolean, e: IonToggleCustomEvent<ToggleChangeEventDetail>) {
        const relay = relaysQuery.data?.[relayId];

        if (!relay || relay.state === on) {
            return;
        }

        await presentResult(async () => {
            await setRelayStateMutation.mutateAsync({id: relayId, state: on});
        }, `${relay.name} turned ${on ? 'on' : 'off'}`);
    }

    return (
        <IonPage>
            <IonHeader translucent={isPlatform('capacitor')} collapse="fade">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/control"/>
                    </IonButtons>
                    <IonTitle>All Relays</IonTitle>
                    {!!(isConnecting || relaysQuery.isPending || setRelayStateMutation.isPending)
                        && <IonProgressBar type="indeterminate"/>}
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen={true}>
                <IonList>
                    {relays.map((relay: any) => (
                        <IonItem key={relay.id}>
                            <IonToggle checked={relay.state} onIonChange={e => setOn(relay.id, e.detail.checked, e)}>
                                {relay.name || relay.id}
                            </IonToggle>
                        </IonItem>
                    ))}
                </IonList>
            </IonContent>
        </IonPage>
    );
};

export default ControlRelays;
